var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lea && _vm.lea.number)?_c('span',[_c('lea-icon',{attrs:{"lea":_vm.lea}}),_vm._v(" "+_vm._s(_vm.lea.name)+" ("+_vm._s(_vm.lea.number)+")\n  ")],1):_c('div',{staticStyle:{"line-height":"38.4px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }